<template>
    <section class="overflow-hidden rounded-card border border-gray-200 bg-white">
        <header class="bg-white px-6 py-4">
            <h3 class="m-0 text-base font-semibold text-body">{{ group.maintainerName }}</h3>
            <p class="m-0 text-xs text-muted">{{ equipmentSummary }} · {{ assetSummary }}</p>
        </header>
        <EquipmentTypeRow v-for="row in group.rows" :key="row.key" :row="row" :years="years" />
    </section>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n';
import EquipmentTypeRow from './EquipmentTypeRow.vue';

const props = defineProps({
    group: {
        type: Object,
        required: true,
    },
    years: {
        type: Array,
        required: true,
    },
});

const equipmentSummary = computed(() =>
    trans('dashboard.v2.preventative_maintenance.timeline.equipment_type_count', { '%d': props.group.equipmentTypeCount }),
);
const assetSummary = computed(() => trans('dashboard.v2.preventative_maintenance.timeline.asset_count', { '%d': props.group.assetCount }));
</script>
